<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu :username="username" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container>
            <div style="margin:30px 110px 30px 110px">
              <div style="max-width:100%">
                <span
                  class="font-weight-bold"
                  style="padding-top:3px;text-decoration:none;font-size:24px"
                >
                  Notifications</span
                >
                <v-btn style="float:right" fab text>
                  <v-menu transition="slide-x-transition" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar style="float:right" v-bind="attrs" v-on="on">
                        <img :src="user.data.photoURL" alt="" />
                      </v-avatar>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-avatar>
                          <img :src="user.data.photoURL" alt="" />
                        </v-list-item-avatar>
                        <v-list-item-content
                          >{{ user.data.displayName }}
                          <!--.substr(0,user.data.displayName.indexOf(' '))--></v-list-item-content
                        >
                      </v-list-item>
                      <v-list-item>
                        <v-item-action>
                          <v-btn small text :to="`/${username}`"
                            >View your page
                            <v-icon small>mdi-arrow-right</v-icon></v-btn
                          >
                        </v-item-action>
                      </v-list-item>
                      <v-list-item
                        v-for="(item, i) in menu"
                        :key="i"
                        :to="item.link"
                      >
                        <v-list-item-icon
                          ><v-icon>{{ item.icon }}</v-icon></v-list-item-icon
                        >
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="logOut()">
                        <v-list-item-icon
                          ><v-icon>mdi-logout</v-icon></v-list-item-icon
                        >
                        <v-list-item-title>Logout</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-btn>
              </div>
              <div style="margin-top:30px">
                <v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader
                ><v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader v-if="loading" type="list-item-two-line">
                </v-skeleton-loader>
                <v-list v-for="(item, i) in notifications" :key="i" two-line>
                  <v-list-item v-if="!loading">
                    <v-list-item-content>
                      <v-list-item-title style="font-size:19px">
                        <span style="text-decoration:none;font-size:15px">
                          {{ item.title }}</span
                        >
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-text="item.message"
                      ></v-list-item-subtitle>
                      <p class="mt-1" style="font-size:12px">
                        {{ item.timestamp }}
                      </p>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="markasRead(i)"
                            fab
                            depressed
                            v-bind="attrs"
                            v-on="on"
                            ><v-icon>
                              mdi-check
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Mark as Read</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </div>
              <!--No New Notifications-->
              <div v-if="notifications.length == 0 && !loading" class="text-center">
                <v-icon color="#e50914" size="100px">mdi-bell-off</v-icon>
                <p style="margin-top:10px">Nothing new here,yet</p>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pa-3 pt-5" style="margin-bottom:100px">
    <v-btn @click="goBack()" text margin="10px"><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
      <v-container>
        <span
          class="font-weight-bold"
          style="padding-top:0px;text-decoration:none;font-size:20px"
        >
          Notifications</span
        >

        <div style="margin-left:0px;max-width:740px">
          <div style="margin-top:24px">
            <v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader>
            <v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader>
            <v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader>
            <v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader
            ><v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader>
            <v-skeleton-loader v-if="loading" type="list-item-two-line">
            </v-skeleton-loader>
            <v-list v-for="(item, i) in notifications" :key="i" two-line>
              <v-list-item v-if="!loading">
                <v-list-item-content>
                  <v-list-item-title style="font-size:19px">
                    <span style="text-decoration:none;font-size:15px">
                      {{ item.title }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.message"
                  ></v-list-item-subtitle>
                  <p class="mt-1" style="font-size:12px">
                    {{ item.timestamp }}
                  </p>
                </v-list-item-content>

                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="markasRead(i)"
                        fab
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        ><v-icon>
                          mdi-check
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Mark as Read</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </div>

          <!--No New Notifications-->
          <div v-if="notifications.length == 0 && !loading" class="text-center">
            <v-icon color="#e50914" size="120px">mdi-bell-off</v-icon>
            <p style="margin-top:10px">Nothing new here, yet</p>
          </div>
        </div>
      </v-container>
    </v-main>

    <BottomMenu class="hidden-lg-and-up" />

    <!--Pay Now -->
    <v-dialog v-model="success" max-width="500">
      <v-card elevation="24" color="red" class=" pa-7 text-center">
        <v-icon size="100px" color="white">mdi-check-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">{{ message }}</p>
        <v-btn @click="done()" elevation="24"> Ok</v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-close-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">
          {{ message }}
        </p>
        <v-btn @click="error = false" elevation="24"> Close</v-btn>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import BottomMenu from "@/components/BottomMenu";
import NavMenu from "@/components/NavMenu";
import { mapGetters, mapState } from "vuex";
import { getAuth, signOut,onAuthStateChanged } from "firebase/auth";
import { doc, updateDoc, arrayRemove } from "firebase/firestore";
import db from "@/db"

export default {
  name: "Dashboard",
  components: {
    BottomMenu,
    NavMenu,
  },

  data() {
    return {
      success: false,
      error: false,
      message: "",
      title: "",
      menu: [
        { icon: "mdi-account", title: "Account", link: "/settings" },
        { icon: "mdi-heart-pulse", title: "Share Link", link: "/share" },
      ],
    };
  },

  computed: {
     ...mapState({
      loading: "loading",
      userData: "userData",
      walletBalance: "walletBalance",
      activities: "activities",
      bankDetails: "bankDetails",
      subscribers: "subscribers",
      notifications: "notifications",
      username: "username",
    }),
    ...mapGetters({
      user: "user",
    }),
  },

   async beforeCreate() {
     if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });

        if (this.notifications == undefined) {
      await this.$store.dispatch("fetchUserData");
    }
   },
  

  methods: {
    goBack(){
      this.$router.go(-1)
    },
    done() {
      location.reload();
    },

    logOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push("/login");
        })
        .catch((error) => {
          console.log(error);
        });
    },
   async markasRead(i){
      const user = doc(db, "users", localStorage.getItem("tippingsKey"))
       await updateDoc(user, {
       'notifications': arrayRemove(this.notifications[i])
       }).then(()=>{
          this.success = true
          this.title = "Marked as read"
          this.message = "This notification has been marked as read"
       })

    }
  },
};
</script>

<style>
div.scrollmenu {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0px 0px 30px 10px;
}

div.scrollmenu .card {
  flex: 0 0 auto;
}

.pulsing {
  box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.897);
  border-radius: 30px;
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}

@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}
</style>
